import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import DPModal from '../../../../../components/DPModal';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import TableBookingsFlat from '../../../../../components/tables/tableBookingsFlat';
import { ItemBooking } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

export const OPSPlanningBookDeletePage = () => {
    const { idUser, data, menu, parameters } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();
    const [bookings, setBookings] = React.useState<ItemBooking[]>();
    const [booking, setBooking] = React.useState<ItemBooking>();

    const handleSearchBookings = async (date: string) => {
        try {

            setLoading(true);
            const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/bookings/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ date: date, idGroupTypes: [2875, 119737] })
            })


            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                setBookings(dataWeb.bookings);

            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleBookDelete = async (booking: ItemBooking) => {
        try {

            setLoading(true);
            const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/bookings/delete',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idBooking: booking.idBooking, obsBooking: "Reserva eliminada por operaciones", override: true, registration: booking.registration })
            })


            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                setTimeout(() => {
                    handleSearchBookings(parameters.date);
                }, 300);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        if (parameters && parameters.date && parameters.date !== "") {
            handleSearchBookings(parameters.date);
        }
    }, [parameters.date]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}
                        description="Esta funcionalidad permite eliminar una reserva para los grupos Instalaciones y Remolcadores">Eliminar reserva</Header>

                    <FormField label="Fecha">
                        <DPModal date={parameters.date} onConfirm={(date) => {
                            setParameters({ ...parameters, date: date });
                        }} clear={false} close={false}
                        />
                    </FormField>
                    {!!bookings && (
                        <TableBookingsFlat bookings={bookings} visible={true} onBookingClick={(book: ItemBooking) => {
                            setBooking(book)
                        }} />
                    )}
                    <ConfirmDelete header='Confirmar eliminación' subtitle={"Se eliminará la reserva seleccionada"} show={!!booking} confirmWord={'eliminar'} action={'Eliminar'} warning={'Esta reserva no se podrá recuperar y se eliminará de todos los usuarios que la tengan asignada.'} onDismiss={() => { setBooking(undefined) }} onConfirm={() => {
                        handleBookDelete(booking)
                    }} />


                </SpaceBetween>
            }
        />
    )
};
